import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import {
  EigentumanteilMasterDetailEntryMeta,
  GbeigentumService,
  GrundstueckId,
  LoadEigentumanteilSichtByGrundstueckIdResponseMeta
} from '../../core/gb-api';
import { NavTarget } from '../../shared/components/link/link.component';
import { TimepointCtx, TimepointService } from '../../core/services/timepoint.service';
import { AppConfigService } from '../../core/services/app-config.service';
import { FormatConfigService } from '../../core/services/format-config.service';
import { AppPermissionService } from '../../core/services/app-permission.service';
import { CapiLoginService } from '../../core/extension/login/capi-login-service';
import { catchError, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { EigentumanteilMasterDetailVM } from '../../core/services/eigentum-viewmodel.service';
import { ListLoaderObservable } from '../../shared/components/list-loader/list-loader-observable';
import { FieldMetaData } from '../../core/av-api';
import { BeschreibungTableWrapperComponent } from '../../shared/components/table/beschreibung-table-wrapper.component';
import { FormatBelegPipe } from '../../shared/pipes/format/format-beleg.pipe';
import { KompaktGrundstueckComponent } from '../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { KompaktTimepointComponent } from '../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { ListLoaderWrapperComponent } from '../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { TranslatePipe } from '@ngx-translate/core';
import { HistoryDirective } from '../../shared/directives/history.directive';
import { NgTemplateOutlet } from '@angular/common';
import { RechtsgrundIcpComponent } from '../shared/component/rechtsgrund-icp/rechtsgrund-icp.component';

@Component({
  selector: 'cap-stammgrundstueck-icp',
  imports: [
    BeschreibungTableWrapperComponent,
    FormatBelegPipe,
    KompaktGrundstueckComponent,
    KompaktTimepointComponent,
    ListLoaderWrapperComponent,
    TranslatePipe,
    HistoryDirective,
    NgTemplateOutlet,
    RechtsgrundIcpComponent
  ],
  templateUrl: './stammgrundstueck-icp.component.html'
})
export class StammgrundstueckIcpComponent extends AbstractComponent implements OnInit, OnChanges, OnDestroy {
  listLoader: ListLoader<EigentumanteilMasterDetailEntryMeta>;
  historischeDatenSubscription;
  hasParzellenindex: boolean;
  rechtsgrundDatumAnzeigen: boolean = true;
  belegeAnzeigen: boolean = false;
  userLoggedIn: boolean = true;
  readonly navigateTo: NavTarget = NavTarget.NAV_GRUNDSTUECK_ES;

  constructor(
    private eigentumService: GbeigentumService,
    private timepointService: TimepointService,
    private appConfigService: AppConfigService,
    private appformatConfigService: FormatConfigService,
    private permissionService: AppPermissionService,
    private loginService: CapiLoginService
  ) {
    super();
  }

  _grundstueckId: GrundstueckId;

  get grundstueckId(): GrundstueckId {
    return this._grundstueckId;
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
  }

  ngOnInit(): void {
    this.userLoggedIn = this.loginService.userLoggedIn;
    this.addSub(
      this.appformatConfigService.parameterConfig$.subscribe((config) => {
        this.rechtsgrundDatumAnzeigen = <any>config?.parameters.ERWERBSDATUM_ANZEIGEN;
        this.belegeAnzeigen = <any>config?.parameters.BELEGEANZEIGEN;
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.grundstueckId.currentValue) {
      return;
    }
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe(() => {
      this.update();
    });
  }

  update(): void {
    const timepointCtx: TimepointCtx = this.timepointService.timepointCtx;
    const observable = this.eigentumService
      .loadEigentumSichtGrundstueck(
        //
        this._grundstueckId.id, //
        false, //
        'BERECHTIGT_NORMAL', //
        this.appConfigService.einstellungHistorischeDaten, //
        timepointCtx.timepointIso, //
        timepointCtx.timepointId //
      )
      .pipe(
        catchError((err) => {
          return of(<LoadEigentumanteilSichtByGrundstueckIdResponseMeta>{
            entries: [new EigentumanteilMasterDetailVM(null, err, 0, null, this.permissionService)],
            lastJunk: true
          });
        })
      )
      .pipe(
        tap((res) => this.setHasParzellenindex(res.entries)),
        map((res) => res.entries)
      );
    this.listLoader = new ListLoaderObservable<EigentumanteilMasterDetailEntryMeta>(undefined, 1, observable);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
  }

  private setHasParzellenindex(entries: Array<EigentumanteilMasterDetailEntryMeta>): void {
    if (entries.length > 0 && entries[0].versions) {
      this.hasParzellenindex = entries[0].versions[0].mParzellenindex.access !== FieldMetaData.AccessEnum.DEACTIVATED;
    }
  }
}
